import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';
import { modals } from '@/mixins/modal';
import vSelect from 'vue-select';
import _ from 'lodash';
import { SITE_ASSET_FOLDERS } from '@/constants';

export default Vue.component('add-site', {
  template: require('./template.html'),
  name: 'add-site',
  mixins: [modals, guid],
  components: {
    vSelect,
  },
  data() {
    return {
      newPath: '',
      loading: false,
      deleteBpLoading: false,
      paginate: ['filteredBoilerplates'],
      sitename: '',
      newPayload: {},
      prefix: 'drz-',
      midfix: '-site-id-',
      searchInput: '',
      confirmSlider: false,
      confirmMsg: '',
      confirmType: 'Del',
      modals: {
        newSite: false,
      },
      selectedPlan: 'Free',
      planErrors: [],
      saveErrors: [],
      addStep: 'name',
      chosenPlate: {},
      editPlate: {},
      lastDroplet: null,
    };
  },
  watch: {
    'modals.newSite': function o(o) {
      if (o) {
        this.resetModal();
      }
    },
  },
  computed: {
    ...mapGetters([
      'websites',
      'account',
      'priceSource',
      'currentUser',
      'identityId',
      'boilerplates',
      'globalLoading',
    ]),
    canAddSite() {
      const owner = this.currentUser.owner;
      const isChurchNoSite = this._isChurch && this.websites.length < 1;
      return owner && (!this._isChurch || isChurchNoSite);
    },
    filteredBoilerplates() {
      const blank = _.find(this.boilerplates, plate => plate.name.match(/Blank Canvas/gi));
      let list = _.filter(this.boilerplates, plate => !plate.name.match(/Blank Canvas/gi));
      if (!this._dev) {
        // we only want to filter out church sites in prod
        if (this._isChurch) {
          list = _.filter(list, plate => plate.category === 'church');
        } else {
          list = _.filter(list, plate => plate.category !== 'church');
        }
      }
      list = _.sortBy(list, plate => new Date(plate.createdOn));
      const searchInput = new RegExp(this.searchInput, 'i');
      if (blank) {
        list.splice(0, 0, blank);
      }
      return list.filter(
        plate => plate.name.match(searchInput) || plate.category.match(searchInput),
      );
    },
    siteNames() {
      const names = [];
      _.forEach(this.websites, (site) => {
        names.push(site.name.toLowerCase());
      });
      return names;
    },
  },
  created() {
    if (this._isBundle) {
      this.selectedPlan = 'Premium';
    }
  },
  mounted() {
    // used for modal mixin
    this.cls = '.adminUi-modalOverlay';
  },
  methods: {
    async nextStep(step) {
      this.saveErrors = [];
      if (this.addStep === 'name') {
        const validated = await this.$validator.validate('sitename', this.sitename);
        if (!validated) {
          return;
        }
        const siteExists = this.siteNames.includes(this.sitename.toLowerCase());
        if (!siteExists) {
          this.addStep = step;
        } else if (siteExists) {
          this.saveErrors.push('A site with that name alreay exists.');
        }
      }
      if (this.addStep === 'boilerplates') {
        if (this.boilerplates.length < 1) {
          await this.loadBoilerPlates();
        } else if (!this.chosenPlate._id) {
          this.chosenPlate = this.filteredBoilerplates[0];
        }
        if (!this.chosenPlate.name) {
          this.saveErrors.push('You need to select a boilerplate.');
          return;
        }
        this.addStep = step;
      }

      if (this.addStep === 'agree') {
        this.addStep = step;
      }
    },
    async loadBoilerPlates() {
      this.loading = true;
      try {
        const boilerplates = await this._SEND([{
          name: 'getBoilerplates',
        }]);
        let list = _.filter(boilerplates.Items, plate => plate.status !== 'pending');
        if (this._dev) {
          list = boilerplates.Items;
        }
        this.$store.dispatch('setBoilerplates', list);
        this.$log.debug('successfully added boilerplates: ', list);
        if (this.filteredBoilerplates.length > 0) {
          this.chosenPlate = this.filteredBoilerplates[0];
        }
      } catch (e) {
        this.$log.error('error: ', e);
      } finally {
        this.loading = false;
      }
    },
    resetModal() {
      this.saveErrors = [];
      this.sitename = '';
      this.newPayload = {};
      this.loading = false;
      this.addStep = 'name';
      this.editPlate = {};
      this.confirmSlider = false;
      this.confirmMsg = '';
      this.confirmType = 'Del';
    },
    async buildNewSite() {
      const noErrors = this.planErrors.length < 1;
      if (noErrors) {
        this.loading = true;
        const notif = {
          id: this.guid(),
          type: 'success',
          message: '',
        };
        let newSite;
        try {
          newSite = await this._SEND([{
            name: 'buildNewSite',
            payload: {
              chosenPlate: this.chosenPlate._id,
              sitename: this.sitename,
              createdDate: new Date().toISOString(),
              assetFolders: SITE_ASSET_FOLDERS,
              selectedPlan: this.selectedPlan,
            },
          }]);
          this.$log.debug('successfully added site: ', newSite);

          // save site to state
          await this.$store.dispatch('saveNewSite', { newSite });

          notif.message = `New site: ${newSite.alias} created successfully!`;
          this.toggleModal('newSite');
          setTimeout(() => {
            this.loading = false;
            this.$store.dispatch('addNotification', notif);
            this.goToDash(newSite);
          }, 500);
        } catch (e) {
          const message = e.message || e;
          this.$log.error('error: ', message);
          this.saveErrors.push(message);
          await this._reportError({
            error: e,
            fn: 'buildNewSite',
          });
        } finally {
          this._trackEvent({
            type: 'build_new_site',
            meta: {
              site_name: this.sitename,
              site_type: this.chosenPlate.site.type,
              selected_plan: this.selectedPlan,
              bp_name: this.chosenPlate.name,
              bp_category: this.chosenPlate.category,
            },
          });
        }
      }
    },
    async goToDash(site) {
      await this.$store.dispatch('setCurrentSite', site);
      this.$router.push({ path: `/edit-site/${site._id}` });
    },
    showConfirm(plate) {
      // scroll page to top
      this.$refs.overlay.scrollTop = 0;
      // show slider
      this.confirmSlider = true;
      // set the plate you're editing
      this.editPlate = plate;
      // delete modals
      if (plate.status === 'pending') {
        this.confirmMsg = 'Are you sure you want to delete this boilerplate?';
      } else if (plate.status === 'active') {
        this.confirmMsg =
          `HOLD ON!!! ${plate.name} is a live boilerplate visible to Drzzle users. Are you absolutely sure you want to do this?`;
      }
    },
    async deleteBoilerplate() {
      this.deleteBpLoading = true;
      const notif = {
        id: this.guid(),
        type: 'success',
        message: 'Successfully deleted boilerplate!',
      };
      try {
        // remove from state first
        const boilerplate = this.editPlate;
        let name = boilerplate.name.toLowerCase();
        name = name.replace(/[^a-zA-Z0-9]/g, '-');
        // delete item from db
        await this._SEND([{
          name: 'deleteBoilerplate',
          payload: {
            _id: boilerplate._id,
            name,
          },
        }]);
        this.$log.debug('successfully deleted boilerplate: ', name);

        this.$store.dispatch('removeBoilerplate', boilerplate);
      } catch (e) {
        this.$log.error('error: ', e);
        notif.type = 'error';
        notif.message = e.message || e;
      } finally {
        this.deleteBpLoading = false;
        this.confirmSlider = false;
        setTimeout(() => {
          this.$store.dispatch('addNotification', notif);
        }, 500);
      }
    },
    choosePlate(plate) {
      this.chosenPlate = plate;
    },
    sanitize() {
      this.sitename = this.sitename.replace(/[^a-zA-Z0-9]/g, '-');
      this.sitename = _.trim(this.sitename);
    },
    setString(type) {
      let t = type;
      if (t.match(/sectionBlock/gi)) {
        t = 'section';
      } else if (t.match(/droplet/gi)) {
        t = 'droplet';
      }
      return t;
    },
    formatErrors(ers) {
      let str = ers.join(' ');
      str = this._startCase(str);
      return str;
    },
    getTip() {
      let tip = '';
      if (!this.currentUser.owner) {
        tip = 'You are not authorized to add sites.';
      }
      if (this._isChurch && this.websites.length > 0) {
        tip = 'Church accounts are currently only allowed one website.';
      }
      return tip;
    },
    openPage(url) {
      window.open(url, '_blank');
    },
    toggleModal(type) {
      this.modals[type] = !this.modals[type];
      const content = this.$refs[type];
      if (this.modals[type]) {
        this.modelMoveOut(content);
      } else {
        this.modalMoveIn(content);
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/websites/add-site/index.js